import { combineReducers } from 'redux';


import lesson from "./lesson/reducer";
import code from "./code/reducer";

export const rootReducer = combineReducers({
    lesson, code
})